import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { BreadcrumbModel } from '@shared/models/breadcrumb.model';
import { Guid } from 'guid-typescript';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { IDac6ReporterState } from '../../../store/reducers/dac6-reporter.reducer';
import { ParticleService } from '@core/services/particle.service';
import {getCurrentBasket, getViewType, ParticleState} from '@shared/store/reducers/particle.reduer';
import { CommandService } from '@core/services/command.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { DialogService } from '@shared/services/dialog-service';
import { Dac6CellDecoratorComponent } from '../../dac6-cell-decorator/dac6-cell-decorator.component';
import { Configuration } from '@shared/models/configuration';
import { SetViewTypeAction } from '@shared/store/actions/particle.actions';
import {
  AddParticipantsCommand,
  DeleteParticipantsCommand, SyncAssociateEntityCommand,
  SyncIntermediariesCommand,
  SyncOtherPersonsCommand,
  SyncProjectEntityToCompanyCommand,
  SyncRelevantTaxpayersCommand,
  UpdateParticipantsCommand
} from '../../../commands/dac6-reporter.command';
import { DialogModel } from '@shared/models/dialog.model';
import { Dac6ReporterConfig } from '../../../orbitax-dac6-reporter-config';
import {take, takeUntil} from 'rxjs/operators';
import {ParticleConfig} from '../../../../particle-config';
import {UpdateFieldDefinitionCommand} from '@shared/commands/update-field-definition.command';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {BasketModel} from '@shared/models/common.models';
import {GetFieldSectionsAction, Dynamic_Grid_Data_Request_Parameters} from '@shared/store/actions/virtual-grid.actions';
import {PlatformCommand} from '@shared/commands/command-base';
import {AddSurveyCommand} from "@shared/commands/shared.commands";
import {ParticleCacheService} from "@core/services/particle-cache.service";
import {SetActivityFeedAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";

@Component({
    standalone: false,
    selector: 'particle-participants-entity-manager',
  templateUrl: './participants-entity-manager.component.html',
  styleUrls: ['./participants-entity-manager.component.scss']
})
export class ParticipantsEntityManagerComponent implements OnInit, OnDestroy {

  sourceType: string;
  itemsUrlIndex: number = 0;
  unSubscribe$ = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  viewType: string;
  filterId: string = '';
  entitySelectorFilterId: string = '';
  filterTemplateId: string = 'dac6-participants-entity-selector-filter';
  endpoint: string = 'Dac6Api';
  deleteEndpoint: string = '';
  addEndpoint: string = '';
  UpdateEndpoint: string = '';
  caseId: string;
  actions: any[];
  configs: any;
  currentConfig: any;
  toolName: string;
  helpNoteId: string;
  fieldHistorySourceType: string = 'Dac6-Field-History';
  hasTabs: boolean;
  selectedBasket: BasketModel;
  constructor( private router: Router,  private store: Store<IDac6ReporterState>,
               private particleService: ParticleService,
               private particleCacheService: ParticleCacheService,
               private particleStore: Store<ParticleState>,
               protected commandService: CommandService,
               private activatedRoute: ActivatedRoute,
               private snackBarService: SnackBarService,
               private platformSidebarStore: Store<PlatformSidebarState>,
               private dialogService: DialogService,
               private fuseSplashScreenService: FuseSplashScreenService
  ) {
    this.configs = {
      'relevant-taxpayers' : {
        sourceType : 'Relevant-Taxpayers',
        itemsUrlIndex : 0,
        header: 'Relevant-Taxpayers',
        deleteEndpoint: `${Dac6ReporterConfig.Dac6ReporterAPI}Command/DeleteRelevantTaxPayers`,
        addEndpoint : `${Configuration.getConfig('Dac6Api')}Command/CreateRelevantTaxpayers`,
        UpdateEndpoint : `${Configuration.getConfig('Dac6Api')}Command/UpdateRelevantTaxpayer`,
        SyncEntityCommand: new SyncIntermediariesCommand('Relevant-Taxpayers'),
        helpNoteId: 'dac6-relevant-taxpayers'
      },
      'intermediaries' : {
        sourceType : 'Intermediaries',
        itemsUrlIndex : 0,
        header: 'Intermediaries',
        deleteEndpoint: `${Dac6ReporterConfig.Dac6ReporterAPI}Command/DeleteIntermediaries`,
        addEndpoint : `${Configuration.getConfig('Dac6Api')}Command/CreateIntermediaries`,
        UpdateEndpoint : `${Configuration.getConfig('Dac6Api')}Command/UpdateIntermediary`,
        SyncEntityCommand: new SyncIntermediariesCommand('Intermediaries'),
        helpNoteId: 'dac6-intermediaries'
      },
      'other-persons' : {
        sourceType : 'Other-Persons',
        itemsUrlIndex : 0,
        header: 'Other Persons',
        deleteEndpoint: `${Dac6ReporterConfig.Dac6ReporterAPI}Command/DeleteOtherPersons`,
        addEndpoint : `${Configuration.getConfig('Dac6Api')}Command/CreateOtherPersons`,
        UpdateEndpoint : `${Configuration.getConfig('Dac6Api')}Command/UpdateOtherPerson`,
        SyncEntityCommand: new SyncIntermediariesCommand('Other-Persons'),
        helpNoteId: 'dac6-other-persons',
        ignoreBasket: ['dac6-mx', 'dac6-gb']
      },
      'associate-enterprises' : {
        sourceType : 'Relevant-Taxpayers',
        itemsUrlIndex : 1,
        header: 'Associate-Enterprises',
        deleteEndpoint: `${Dac6ReporterConfig.Dac6ReporterAPI}Command/DeleteRelevantTaxPayers`,
        addEndpoint : `${Configuration.getConfig('Dac6Api')}Command/CreateRelevantTaxpayers`,
        UpdateEndpoint : `${Configuration.getConfig('Dac6Api')}Command/UpdateRelevantTaxpayer`,
        SyncEntityCommand: new SyncIntermediariesCommand('Relevant-Taxpayers'),
        helpNoteId: 'dac6-associate-enterprises'
      }
    };
    this.particleService.registerCellComponent('Dac6CellDecorator', Dac6CellDecoratorComponent);
    this.viewType = 'Expanded';
    this.caseId = '';
    this.invalidateSubject = new InvalidateSubject();
    this.createActions();
  }
 createActions() {
   this.actions = [
     {
       text: 'Add Record',
       doAction: this.Add,
       self: this
     },
     {
       text: 'Manage Entities',
       doAction: this.manageEntities,
       self: this
     },
     {
       text: 'Import',
       doAction: this.import,
       self: this
     },
     {
       text: 'Export',
       doAction: this.export,
       self: this
     },
     {
       text: 'Manage Fields',
       doAction: this.manageSection,
       self: this
     },
     {
       text: 'Start Survey',
       doAction: this.startDataSurvey,
       self: this
     }
   ];
 }
  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.unSubscribe$)).subscribe(params => {
      this.toolName = params.toolName;
      this.sourceType = null;
      this.caseId = params['caseId'];
      setTimeout(() => {
        this.invalidate();
      }, 10);
    });
    this.particleStore.pipe(select(getViewType)).subscribe(viewType => {
      this.viewType = viewType;
    });
    this.particleStore.pipe(select(getCurrentBasket), takeUntil(this.unSubscribe$)).subscribe((item: BasketModel) => {
      if (item) {
        this.selectedBasket = item;
      }
    });
  }

  private invalidate() {
    this.currentConfig = this.configs[this.toolName];
    this.sourceType = this.currentConfig.sourceType;
    this.itemsUrlIndex = this.currentConfig.itemsUrlIndex;
    this.filterId = Configuration.getBasketMappedSourceType(this.sourceType);
    this.entitySelectorFilterId = this.sourceType + '-Manage-Entities-Filter-' + Guid.create().toString();
    this.deleteEndpoint = this.currentConfig.deleteEndpoint;
    this.addEndpoint = this.currentConfig.addEndpoint;
    this.UpdateEndpoint = this.currentConfig.UpdateEndpoint;
    this.createBreadcrumbs();
    const gridConfig = Configuration.getSmartGridConfig(this.sourceType);
    if (this.caseId) {
      this.breadcrumbs.push(<BreadcrumbModel>{
        id         : this.caseId,
        title      : this.caseId,
        type       : this.caseId,
        relativeUrl: `dac6-reporter/participants/${this.toolName}/${this.caseId}`
      });
      gridConfig.Parameters['CASE_ID'] = this.caseId;
      gridConfig.ItemsUrlIndex = this.itemsUrlIndex;
    } else {
      this.caseId = '';
      gridConfig.Parameters['CASE_ID'] = '';
    }
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType, {'CASE_ID':this.caseId});
    this.invalidateSubject.invalidate();
  }

  private createBreadcrumbs() {
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'Case',
        title: 'DAC6 & MDR Reporter',
        type: 'Case',
        relativeUrl: 'dac6-reporter/overview'
      },
      <BreadcrumbModel>{
        id: this.toolName,
        title: this.currentConfig.header,
        type: this.currentConfig.sourceType,
        relativeUrl: 'dac6-reporter/participants/' + this.toolName
      }
    ];
  }

  viewTypeChanged($event) {
    this.particleStore.dispatch(new SetViewTypeAction($event));
  }

  compactViewType() {
    this.particleStore.dispatch(new SetViewTypeAction('Compact'));
  }

  onSelectedTabChanged($event) {}

  onCellEditorClosed(event) {
    console.log(event);
    this.router.navigate(['']);
  }

  onSelectionChanged(event) {}

  addSection() {
    this.router.navigate(['add-section/' + this.sourceType], {relativeTo: this.activatedRoute});
  }

  manageSection() {
    const command = new PlatformCommand('CreateManageFieldMagicLinkCommand', 'Dac6Api');
    command.fieldValues['SourceType'] = Configuration.getBasketMappedSourceType(this.sourceType);
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      console.log('commandState', response);
      if (response.fieldValues['RedirectUrl']) {
        this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
      }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed to managesection ', error);
      });
  }

  export() {
    this.router.navigate(['export'], {relativeTo: this.activatedRoute});
  }
  exportByCaseId() {
    this.router.navigate(['export'], {relativeTo: this.activatedRoute});
  }
  Add() {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new AddParticipantsCommand(this.addEndpoint)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      if (state && state.Payload) {
        this.snackBarService.showInformation(`${state.Payload.FieldValues.EntityCode} is added`);
        this.invalidateSubject.invalidate();
      }
    });
  }

  manageEntities() {
    if (this.sourceType === 'Relevant-Taxpayers') {
      const syncCommand = new SyncProjectEntityToCompanyCommand(true);
      this.commandService.executeCommand(syncCommand).pipe().subscribe(state => {
        this.navigateToManageEntities();
      });
    } else {
      this.syncEntitiesProcess();
    }
  }
  syncEntitiesProcess() {
    const command = new SyncProjectEntityToCompanyCommand(false);
    this.commandService.executeCommand(command).pipe().subscribe(commandState => {
      console.log(commandState);
      if (commandState.Payload.ConfirmationNeeded) {
        this.dialogService.showYesNoDialog('Confirm Sync', `You were working with the entities of project '${commandState.Payload.Configuration.ProjectModel.Name}'. Do you want to sync with the current project?`)
          .subscribe(state => {
            if (state.action === 'OK') {
              const syncCommand = new SyncProjectEntityToCompanyCommand(true);
              this.commandService.executeCommand(syncCommand).pipe().subscribe(commandState2 => {
                console.log(commandState2);
                this.navigateToManageEntities();
              });
            } else {
              this.navigateToManageEntities();
            }
          });
      } else {
        this.navigateToManageEntities();
      }
    });
    return;
  }

  startDataSurvey() {
    const { flag } = this.selectedBasket;
    const bucket = flag === 'MX' ? '-MX' : '';
    const title = `${this.currentConfig.sourceType}${bucket}`;
    const parameters = {'SourceTypes': [`Relevant-Taxpayers${bucket}`, `Relevant-Taxpayers${bucket}`, `Intermediaries${bucket}`, `Other-Persons${bucket}`]};
    this.dialogService.createOrLoadDefaultSurveyTemplate(title, false, false, null, parameters);
  }

  import() {
    this.router.navigate(['import'], {relativeTo: this.activatedRoute});
  }
  navigateToManageEntities() {
    this.router.navigate(['manage-entities'], {relativeTo: this.activatedRoute});
  }
  onGridCellValueChange(event) {
    if (event.fieldDefinition && event.fieldDefinition.key === 'CaseId') {
      this.router.navigate(['./detail', event.item.id], {relativeTo: this.activatedRoute});
      return;
    }
    if (event.action) {
      switch (event.action.id) {
        case 'Open':
          this.router.navigate(['detail/', event.item.id], {relativeTo: this.activatedRoute});
          break;
        case 'Edit':
          this.edit(event);
          break;
        case 'Delete':
          const command = new DeleteParticipantsCommand([event.item.id], this.deleteEndpoint);
          this.fuseSplashScreenService.show();
          this.commandService.executeCommand(command).subscribe(state => {
            if (state) {
              this.fuseSplashScreenService.hide();
              this.invalidateSubject.invalidate();
              this.snackBarService.showInformation('Deleted Successfully');
            }
          });
          break;
        case 'ViewActivity':
          this.trackEntityActiviy(event);
          break;
      }
    }
    console.log(event);
  }
  private trackEntityActiviy(event: any) {
    this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', id: event.item.cells['ReferenceCode'].value, title: event.item.cells['EntityCode'].value, isDefault: false, isUserAction: true}));
  }

  edit(event: any) {
    this.openEditor(event);
  }

  public openEditor(event: any) {
    let minWidth = '400px';
    let maxWidth = '1500px';
    if (event.fieldDefinition.key === 'RtpAssociateEnterprise') {
      minWidth = '900px';
      maxWidth = '900px';
    }
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.sourceType, this.fieldHistorySourceType)
      .subscribe(state => {
        console.log('After Edit', state);
        if (state.action === 'OK') {
          if (event.fieldDefinition.key === 'RtpAssociateEnterprise') {
            const command = new SyncAssociateEntityCommand(event.item.id);
            this.commandService.executeCommand(command).subscribe(commandState => {
              console.log('Sync Success');
            });
            this.invalidateSubject.invalidate();
            return;
          }
          this.saveFieldDefinition(state.data.input.fieldDefinition, event.fieldSection);
          const item = {id: event.item.id, fieldValues: {}};
          const value = event.item.cells[event.fieldDefinition.key].value;
          item.fieldValues[event.fieldDefinition.key] = value;
          console.log(item);
          const command = new UpdateParticipantsCommand(item, this.UpdateEndpoint);
          this.commandService.executeCommand(command).pipe().subscribe(commandState => {
            console.log(commandState);
            this.invalidateSubject.invalidate();
          });
        } else if (state.action == 'Cancel') {
          if (event.fieldDefinition.key === 'RtpAssociateEnterprise') {
            const command = new SyncAssociateEntityCommand(event.item.id);
            this.commandService.executeCommand(command).subscribe(commandState => {
              console.log('Sync Success');
            });
            this.invalidateSubject.invalidate();
            return;
          }
        }
      });
  }

  saveFieldDefinition(fieldDefinition: any, selectedFieldSection: any) {
    let fieldSettings = null;
    if (fieldDefinition && fieldDefinition.configKey) {
      const fieldConfig = Configuration.getSmartGridConfig(fieldDefinition.configKey);
      if (fieldConfig && fieldConfig.FieldSettings) {
        fieldSettings = fieldConfig.FieldSettings;
      }
    }
    if (fieldSettings) {
      const rootUrlKey = Configuration.getSmartGridConfig(this.sourceType).RootUrlKey;
      const url = `${Configuration.getConfig(rootUrlKey)}FieldSection/UpdateFieldDefinition`;
      const config = Configuration.getSmartGridConfig(this.sourceType);
      if (config) {
        const sourceType = config.SourceType;
        const updateFieldDefinitionCommand = new UpdateFieldDefinitionCommand([fieldDefinition], selectedFieldSection.id, ParticleConfig.ApplicationId, sourceType, true,
          url, !Configuration.getSmartGridConfig(this.sourceType).IsCompanySpecific);
        this.commandService.executeCommand(updateFieldDefinitionCommand).pipe().subscribe(commandState => {
          this.invalidateSubject.invalidate();
        });
      }
    }
  }
  onBasketChange(event: BasketModel) {
    if(this.sourceType){
      this.filterId = null;
      setTimeout(()=>{
        this.filterId = Configuration.getBasketMappedSourceType(this.sourceType);
      }, 200);
    }
  }
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onFieldSectionChanged($event: any) {
    this.hasTabs = $event.length > 1;
  }
}
